interface Props {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

export default function PrimaryButton({ label, onClick, disabled }: Props) {
  return (
    <button className="btn-primary" onClick={onClick} disabled={disabled}>
      {label}
    </button>
  );
}
